// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/pmahmud/dev/projects/chorki/docs/src/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/pmahmud/dev/projects/chorki/docs/src/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("/Users/pmahmud/dev/projects/chorki/docs/src/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

